import HeaderDashboard from '../Components/HeaderDashboard'
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FlightBookingDetails } from "../Services/API"

const BookingDetails = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const referenceNo = queryParams.get("referenceNo");
    const trackId = queryParams.get("trackID");

    const [flightDetails, setFlightDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    useEffect(() => {
        if (referenceNo) {
            fetchFlightBookingDetails(referenceNo);
        } else {
            console.warn("Missing referenceNo and trackId");
        }
    }, [referenceNo], [trackId]);

    const fetchFlightBookingDetails = async (referenceNo) => {
        try {
            setLoading(true);
            setError("");
            const params = { ReferenceNo: referenceNo, TrackID: "", ClientCode: "BerryJourneys", Key: "", SessionID: "" };
            const response = await FlightBookingDetails(params);
            setFlightDetails(response);
            console.log(response.status)
            debugger;
        } catch (err) {
            setError("Failed to load flight Booking details. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <HeaderDashboard></HeaderDashboard>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">My Booking</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/Settings/Bands" className="text-muted text-hover-primary">Booking Details</a>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
            </div>
            <section className='wraper'>
                <div className='box_shadow mt-14'>
                    {/* flightDetails.status ==="Confirmed" && */}

                    {flightDetails && flightDetails.airBookingResponse.length > 0 ? (
                        <>
                            <div class="row mamage_depo">
                                <div class="col-lg-6">
                                    <h6 className='ruler'>Flight Booking Details</h6>
                                </div>
                                <div class="col-lg-6 text-right">
                                    <ul class="option_s">
                                        <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="Print Ticket"> <img src="/assets/images/printer.png" alt="train" /></a></li>
                                        <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="cancel Ticket"> <img src="/assets/images/cancel.png" alt="train" /></a></li>
                                        <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="PNR Status"><img src="/assets/images/ticket.png" alt="train" /></a></li>
                                        <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="Agency Invoice"><img src="/assets/images/Invoice.png" alt="train" /></a></li>
                                        <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="Customer Invoice"><img src="/assets/images/Invoice.png" alt="train" /></a></li>
                                        <li><a href="" data-bs-toggle="tooltip" data-bs-placement="top" title="File TDR Details"><img src="/assets/images/folder.png" alt="train" /></a></li>

                            </ul>
                        </div>
                    </div>
                    <div className='col-md-12 col-lg-12'>

                                <div className='table-responsive'>
                                    <table className='table table-bordered'>
                                        <thead>
                                            <tr>
                                                <th>Reference No</th>
                                                <th>Confirmation Number (PNR)</th>
                                                <th>Booking Status</th>
                                                <th>Ticketing Status</th>
                                                <th>Booking Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>D2WFA1988</td>
                                                <td>FYZ2UF</td>
                                                <td>Confirmed</td>
                                                <td>Confirmed</td>
                                                <td>Tue 02 Sep , 2025</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='col-md-12 col-lg-12'>
                                <h6 className='ruler'>Travel Information</h6>
                                <div className='table-responsive'>
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>Travel Date</th>
                                                <th>Flight No.</th>
                                                <th>Aircraft Type</th>
                                                <th>From / Terminal </th>
                                                <th>To / Terminal</th>
                                                <th>Dep Time</th>
                                                <th>Arr Time</th>
                                                <th>Airline</th>
                                            </tr>


                                            <tr>
                                                <td>Tue  23 Sep , 2025</td>
                                                <td>
                                                    SG -   12
                                                </td>
                                                <td><samp>N/A</samp></td>
                                                <td class="dropdown-caps">DXB / 1</td>
                                                <td class="dropdown-caps">DEL / 3</td>
                                                <td>23-Sep-2025,10:30,PM</td>
                                                <td>24-Sep-2025,03:55,AM</td>
                                                <td>SpiceJet</td>
                                            </tr>
                                            <tr>
                                                <td>Wed  24 Sep , 2025</td>
                                                <td>
                                                    SG -  475
                                                </td>
                                                <td><samp>N/A</samp></td>
                                                <td class="dropdown-caps">DEL / 1D</td>
                                                <td class="dropdown-caps">DBR / 1</td>
                                                <td>24-Sep-2025,10:30,AM</td>
                                                <td>24-Sep-2025,12:15,PM</td>
                                                <td>SpiceJet</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='col-md-12 col-lg-12'>
                                <h6 className='ruler'>Contact Information</h6>
                                <div className='table-responsive'>
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>Preferred Mobile No</th>
                                                <th>Email address </th>
                                            </tr>
                                            <tr valign="top">
                                                <td>
                                                    <div id="phone">+971 527874282</div>
                                                </td>
                                                <td>
                                                    <div id="phone">support@d2wtravel.com</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='col-md-12 col-lg-12'>
                                <h6 className='ruler'>Passenger Information</h6>
                                <div className='table-responsive'>
                                    <table class="table table-bordered hide--mobile">
                                        <tbody>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Passenger Name</th>
                                                <th>Pax Type</th>
                                                <th>Date of Birth</th>

                                            </tr>

                                            <tr valign="top">
                                                <td>1 .</td>
                                                <td>Mr        . JIVACHHA CHAUPAL</td>
                                                <td>
                                                    ADULT
                                                </td>
                                                <td>01-Jan-1982</td>


                                            </tr>
                                            <tr valign="top">
                                                <td>2 .</td>
                                                <td>Mr. ROHIT SHARMA</td>
                                                <td>
                                                    ADULT
                                                </td>
                                                <td>01-Jan-1989</td>


                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='col-md-12 col-lg-12'>
                                <h6 className='ruler'>Ticket Information</h6>
                                <div className='table-responsive'>
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th width="15">S.No</th>
                                                <th>Passenger Name</th>
                                                <th>ETicket-No</th>
                                                <th>Status</th>
                                            </tr>

                                            <tr valign="top">
                                                <td>1 .</td>
                                                <td>MR JIVACHHA CHAUPAL</td>
                                                <td>FYZ2UF</td>
                                                <td>Ticketed</td>
                                            </tr>
                                            <tr valign="top">
                                                <td>2 .</td>
                                                <td>MR ROHIT SHARMA</td>
                                                <td>FYZ2UF</td>
                                                <td>Ticketed</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='col-md-12 col-lg-12'>
                                <h6 className='ruler'>Payment Information(Fare Details)</h6>
                                <div className='table-responsive'>
                                    <table class="table table-bordered hide--mobile">
                                        <tbody><tr>
                                            <th>Total Fare</th>
                                            <th>Base Fare</th>
                                            <th>Taxes</th>
                                            <th>Aff Comm %</th>
                                            <th>AffComm Amt</th>
                                            <th>GSTon AffComm Amt</th>
                                            <th>NetAff Comm Amt</th>
                                            <th>TdsOn Commission</th>
                                            <th>Amount Payable</th>
                                        </tr>
                                            <tr>
                                                <td><i class="fa fa-inr" aria-hidden="true"></i>5800</td>
                                                <td>4525</td>
                                                <td>0</td>
                                                <td>0%</td>
                                                <td><i class="fa fa-inr" aria-hidden="true"></i>0</td>
                                                <td><i class="fa fa-inr" aria-hidden="true"></i>0</td>
                                                <td><i class="fa fa-inr" aria-hidden="true"></i>0</td>
                                                <td><i class="fa fa-inr" aria-hidden="true"></i>0</td>
                                                <td><i class="fa fa-inr" aria-hidden="true"></i>0</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3}>
                                                    <span>
                                                        Total Price:
                                                    </span>
                                                    <span><b><i class="fa fa-inr" aria-hidden="true"></i> 842.00</b></span>
                                                </td>
                                                <td colSpan={3}>
                                                    <span>
                                                        SSR Amount:
                                                    </span>
                                                    <span><b><i class="fa fa-inr" aria-hidden="true"></i> 0.00</b></span>
                                                </td>
                                                <td colSpan={3}>
                                                    <span>
                                                        Grand Total Fare:
                                                    </span>
                                                    <span><i class="fa fa-inr" aria-hidden="true"></i> 842.00</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={3}>
                                                    <span>
                                                        Class Of Service:
                                                    </span>
                                                    <span><b></b></span>
                                                </td>
                                                <td colSpan={3}>
                                                    <span>
                                                        RBD:
                                                    </span>
                                                    <span><b></b></span>
                                                </td>
                                                <td colSpan={3}>
                                                    <span>
                                                        Fare Basis Code:
                                                    </span>
                                                    <span><b></b></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='col-md-12 col-lg-12'>
                                <h6 className='ruler'>Baggage Details</h6>
                                <div className='table-responsive'>
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span>
                                                        Pax :
                                                    </span>
                                                    <span><b> ADT</b></span>
                                                </td>
                                                <td>
                                                    <span>
                                                        Sector :
                                                    </span>
                                                    <span><b> DXB - DBR</b></span>
                                                </td>
                                                <td>
                                                    <span>
                                                        Baggage :
                                                    </span>
                                                    <span><b> 30 Kg</b></span>
                                                </td>
                                                <td>
                                                    <span>
                                                        Cabin Baggage :
                                                    </span>
                                                    <span><b> 07 Kg</b></span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='col-md-12 col-lg-12'>
                                <h6 className='ruler'>Transaction Summary</h6>
                                <div className='table-responsive'>
                                    <table class="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <th>Payment Status</th>
                                                <th>Amount Paid</th>
                                                <th>Created On</th>
                                            </tr>
                                            <tr>
                                                <td>Success</td>
                                                <td><i class="fa fa-inr" aria-hidden="true"></i> 842.00</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-lg-12 important_info">
                                <h4>IMPORTANT INFORMATION</h4>
                                <ul>
                                    <li>You must web check-in on the airline website and obtain a boarding pass.</li>
                                    <li>It is mandatory to wear a mask and carry other protective gear.</li>
                                    <li>
                                        Reach the terminal at least 2 hours prior to the departure for domestic flight and 4 hours prior to the departure of international flight.
                                    </li>
                                    <li>For departure terminal please check with the airline first.</li>
                                    <li>Date &amp; Time is calculated based on the local time of the city/destination.</li>
                                    <li>Use the Airline PNR for all Correspondence directly with the Airline</li>
                                    <li>For rescheduling/cancellation within 4 hours of the departure time contact the airline directly</li>
                                    <li>
                                        Your ability to travel is at the sole discretion of the airport authorities and we shall not be held responsible.
                                    </li>

                                </ul>
                            </div>
                        </>
                    ) : (
                        <>
                            <div class="row mamage_depo">
                                <div class="col-lg-12">
                                    <h6 className='ruler'>Flight Booking Details</h6>
                                </div>
                                <div class="col-lg-12">
                                    <p className=''>No Flight Booking Details Found !!</p>
                                </div>
                            </div>
                        </>
                    )
                    }
                </div>
            </section>

        </>
    );
};

export default BookingDetails;